import axios from 'axios';
/**
 * api 호출
 */

// const vodUrl = 'https://voddev-api.jei.com'; // 개발서버 //http://voddev-api.jei.com
//const vodUrl = 'https://vod-api.jei.com'; // 실제서버
const vodUrl = process.env.REACT_APP_WEB_HOST
const vodUrl2 = process.env.REACT_APP_WEB_HOST2
// console.log(vodUrl)

const clientRequest = axios.create({
  baseURL: vodUrl,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    Authorization: `Basic OTQ5MzgxMDItODA0RC00Njk2LThCQ0UtNkVCRkJEN0U0OEU0OkNFNEQ2Q0IxLTJCNTktNDQwOC05OUYxLTlBOEJBOTE5MDgxQg==`,
  },
});

const clientRequest2 = axios.create({
  baseURL: vodUrl2,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    Authorization: `Basic OTQ5MzgxMDItODA0RC00Njk2LThCQ0UtNkVCRkJEN0U0OEU0OkNFNEQ2Q0IxLTJCNTktNDQwOC05OUYxLTlBOEJBOTE5MDgxQg==`,
  },
});

clientRequest.interceptors.request.use((config) => {
  config.headers.Authorization = 'Basic OTQ5MzgxMDItODA0RC00Njk2LThCQ0UtNkVCRkJEN0U0OEU0OkNFNEQ2Q0IxLTJCNTktNDQwOC05OUYxLTlBOEJBOTE5MDgxQg==';
  return config;
});

export const createGetRequest = (url, body) => clientRequest.get(url, body).then((r) => r.data);
export const createPostRequest = (url, body) => clientRequest.post(url, body).then((r) => r.data);
export const createPostRequest2 = (url, body) => clientRequest2.post(url, body).then((r) => r.data);